import { get } from 'lodash';
import { useContext } from 'react';
import { Button } from '@cimpress-ui/react';
import { RetryContext } from '../Retry/RetryContext';
import { Environment, Item } from '../../types';

export const RetryAllButton = ({
  environment,
  accessToken,
  items,
}: {
  environment: Environment;
  accessToken: string;
  items: Item[];
}) => {
  const { retryRoutingRequest, setRetryState, retryState } = useContext(RetryContext);
  const isRetrying = retryState === 'PENDING';

  const handleRetry = () => {
    // Cimpress UI automatically prevents event propagation for press events,
    // so we don't need to call event.stopPropagation() here

    if (!items.length || !retryRoutingRequest) {
      return;
    }

    const routingRequestId = get(items[0], ['_links', 'routingRequest', 'name']) as string | undefined;
    if (!routingRequestId) {
      return;
    }

    setRetryState('PENDING');

    retryRoutingRequest.mutate({
      environment,
      accessToken,
      routingRequestId,
    });
  };

  return (
    <Button variant="secondary" isDisabled={isRetrying} onPress={handleRetry} data-testid="retry-all-button">
      {isRetrying ? 'Retrying all...' : 'Retry all'}
    </Button>
  );
};
